import {publishOpenCopilotChat} from '@github-ui/copilot-chat/utils/copilot-chat-events'
import {CopilotChatIntents, type FileDiffReference} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {copilotFeatureFlags} from '@github-ui/copilot-chat/utils/copilot-feature-flags'
import {copilotLocalStorage} from '@github-ui/copilot-chat/utils/copilot-local-storage'
import {getExplainDiffPrompt} from '@github-ui/copilot-chat/utils/prompts'
import {sendEvent} from '@github-ui/hydro-analytics'
import {ActionList} from '@primer/react'

export interface DiffLinesExplainMenuItemProps {
  fileDiffReference: FileDiffReference
  eventContext?: Parameters<typeof sendEvent>[1]
  afterSelect?: () => void
}

export const DiffLinesExplainMenuItem: React.FC<DiffLinesExplainMenuItemProps> = ({
  fileDiffReference,
  eventContext,
  afterSelect,
}) => {
  const handleExplain = () => {
    if (copilotFeatureFlags.copilotRedirectDiffViewToImmersive) {
      sendEvent('copilot.file-diff.explain', {target: 'file-diff', mode: 'immersive'})
      copilotLocalStorage.setCopilotDiffReferences(fileDiffReference)
      copilotLocalStorage.setEntrypointMessage({message: getExplainDiffPrompt(), references: [fileDiffReference]})
      window.location.href = '/copilot'
    } else {
      sendEvent('copilot.file-diff.explain', {
        target: 'file-diff',
        mode: 'assistive',
        ...eventContext,
      })
      publishOpenCopilotChat({
        content: getExplainDiffPrompt(),
        intent: copilotFeatureFlags.diffExplainConversationIntent
          ? CopilotChatIntents.conversation
          : CopilotChatIntents.explainFileDiff,
        references: [fileDiffReference],
      })
      afterSelect?.()
    }
  }

  return <ActionList.Item onSelect={handleExplain}>Explain</ActionList.Item>
}
